/**
 * Функция возвращает id предвыбранного курса
 * (id достается из GET-параметров ссылки на форму заявки)
 *
 *
 * @param array
 * @returns {string}
 *
 * доп. 01.02.2021 - ivans
 * Здесь до сих пор не проверялось наличие переданного в GET-параметре id курса в соотв. форме заявки, а это может порождать проблемы.
 * Исправлено для order.js и tl.js, доп. материалы (cart.js) не трогал.
 */
function getPredefinedCourse (coursesIds) {
    var course;
    /**
     * Awesome Mr. Hankey's Christmas Classics
     *
     * Отвечаю, со времён института это самый лютый треш, который мне приходится писать осознанно
     * Видит Бог, я этого не хотел, но на меня давил Игорь:
     * - Давай - говорит - что тут такого? Я сто раз так делал!
     * Ну я и дал...
     *
     * Если вам понадобится, вертикальное выделение на линуксе Win + Alt + Click
     *
     * @viktor
     *
     * @type {*}
     *
     * P.S. Возможно, на февр.2021 этот хеш уже не актуален, нужно доп. проверить (ivans)
     */
    var coursesHash = {
        5:77,
        22:23,
        23:24,
        24:25,
        25:27,
        26:26,
        27:28,
        28:29,
        29:30,
        30:31,
        31:32,
        32:33,
        33:34,
        34:35,
        35:36,
        36:37,
        37:38,
        38:39,
        39:40,
        40:41,
        41:42,
        42:43,
        43:44,
        44:45,
        45:46,
        46:47,
        47:48,
        48:44,
        49:50,
        50:51,
        51:52,
        52:53,
        53:54,
        54:55,
        55:56,
        56:57,
        57:58,
        58:59,
        59:60,
        60:61,
        61:62,
        62:63,
        63:64,
        64:65,
        65:66,
        66:67,
        67:68,
        69:70,
        70:69,
        71:70,
        72:71,
        73:72,
        74:73,
        75:74,
        76:75,
        77:76,
        78:22,
        79:26,
        80:77
    };

    course = window.location.search.match(/course=(\d+)/ig);
    if (course !== null) {
        course = course[0].replace(/course=/ig, '');
        return typeof coursesHash[course] !== 'undefined' ? coursesHash[course] : course;
    }

    course = window.location.search.match(/courseId=(\d+)/ig);
    if (course !== null) {
        course = course[0].replace(/courseId=/ig, '');
        // возвращаем id переданного курса при его наличии в нашей форме
        return (Array.isArray(coursesIds) && coursesIds.length > 0 && coursesIds.indexOf(course) !== -1)
                 ? course : '';
    }
    return '';
}
